<template>
    <div>
        <uploader :options="options"
                  :autoStart="true"
                  :file-status-text="statusText"
                  @file-added="fileAdded"
                  @upload-start="uploadStart"
                  @file-complete="fileComplete"
                  @file-removed="fileRemoved"
                  @complete="complete"
                  @files-submitted="fileSubmitted"
                  @file-success="onFileSuccess"
                  @file-progress="onFileProgress"
                  @file-error="onFileError"
                  ref="uploader"
                  class="uploader-example" >
            <uploader-unsupport></uploader-unsupport>
            <uploader-drop>
                <!--<p>Drop files here to upload or</p>-->
                <uploader-btn>select files</uploader-btn>
                <uploader-btn :attrs="attrs" :single="true">select images</uploader-btn>
                <uploader-btn :directory="true">select folder</uploader-btn>
            </uploader-drop>
            <uploader-list></uploader-list>
        </uploader>
    </div>
</template>

<script>
    //import { mergeFile } from "@api/upload.js";
    //import qs from 'qs';
    export default {
        data () {
          return {
            options: {
                // https://github.com/simple-uploader/Uploader/tree/develop/samples/Node.js
                target: this.$store.state.sysApi+'/sys/file/uploadFileSlice',//目标上传 URL，可以是字符串也可以是函数，如果是函数的话，则会传入 Uploader.File 实例、当前块 Uploader.Chunk 以及是否是测试模式，默认值为 ‘/‘
                testChunks: false, //是否测试每个块是否在服务端已经上传了，主要用来实现秒传、跨浏览器上传等，默认true。
               /* target: this.$store.state.sysApi+'/uploader/singlefile',
                testChunks: false, *///是否分片-不分片
                simultaneousUploads: 2, //并发上传数，默认3。
                chunkSize: 10 * 1024 * 1024, //分块时按照该值来分。最后一个上传块的大小是可能是大于等于1倍的这个值但是小于两倍的这个值大小，默认 110241024。
                forceChunkSize: false, //是否强制所有的块都是小于等于 chunkSize 的值
                singleFile: false,
                fileParameterName: 'file', //上传文件时文件的参数名，默认 file。
                progressCallbacksInterval: 500,
                speedSmoothingFactor: 0.1,
                query: {

                },//其他额外的参数，这个可以是一个对象或者是一个函数，如果是函数的话，则会传入 Uploader.File 实例、当前块 Uploader.Chunk 以及是否是测试模式，默认为 {}。
                headers: {},//额外的一些请求头，如果是函数的话，则会传入 Uploader.File 实例、当前块 Uploader.Chunk 以及是否是测试模式，默认 {}。
                withCredentials: false,//标准的 CORS 请求是不会带上 cookie 的，如果想要带的话需要设置 withCredentials 为 true，默认 false。
                preprocess: null, //可选的函数，每个块在测试以及上传前会被调用，参数就是当前上传块实例 Uploader.Chunk，注意在这个函数中你需要调用当前上传块实例的 preprocessFinished 方法，默认 null。
                method: 'multipart',//当上传的时候所使用的是方式,可选 multipart、octet，默认 multipart
                //testMethod: 'get', //测试的时候使用的 HTTP 方法，可以是字符串或者函数，如果是函数的话，则会传入 Uploader.File 实例、当前块 Uploader.Chunk，默认 GET。
                uploadMethod: 'POST', //真正上传的时候使用的 HTTP 方法，可以是字符串或者函数，如果是函数的话，则会传入 Uploader.File 实例、当前块 Uploader.Chunk，默认 POST。
                prioritizeFirstAndLastChunk: false, //对于文件而言是否高优先级发送第一个和最后一个块。一般用来发送到服务端，然后判断是否是合法文件；例如图片或者视频的 meta 数据一般放在文件第一部分，这样可以根据第一个块就能知道是否支持；默认 false。
                allowDuplicateUploads: false,// 是否允许重复上传，如果说一个文件以及上传过了是否还允许再次上传。默认的话如果已经上传了，除非你移除了否则是不会再次重新上传的，所以也就是默认值为 false。
                generateUniqueIdentifier: null,
                maxChunkRetries: 0,
                chunkRetryInterval: null,
                permanentErrors: [404, 415, 500, 501],
                successStatuses: [200, 201, 202],
                onDropStopPropagation: false,
                initFileFn: null,
                checkChunkUploadedByResponse: null,
                //每一次分片传给后台的参数，params是该方法返回的形参，包含分片信息
                processParams(params) {
                    //返回一个对象，会添加到每一个分片的请求参数里面
                    this.returnProcessParams(params);
                },
                /**
                 * 格式化剩余时间。以下代码把英文时间转成中文：
                 * @param timeRemaining
                 * @param parsedTimeRemaining
                 * @returns {*}
                 */
                parseTimeRemaining: function (timeRemaining, parsedTimeRemaining) {
                    return parsedTimeRemaining
                        .replace(/\syears?/, '年')
                        .replace(/\days?/, '天')
                        .replace(/\shours?/, '小时')
                        .replace(/\sminutes?/, '分钟')
                        .replace(/\sseconds?/, '秒')
                }
            },
            attrs: {
                accept: 'image/*',
            },
            statusText: {
                success: '成功了',
                error: '出错了',
                uploading: '上传中',
                paused: '暂停中',
                waiting: '等待中'
            },
            //panelShow: false,   //选择文件后，展示上传panel
          }
        },
        methods: {
            /**
             * 返回一个对象，会添加到每一个分片的请求参数里面
             * */
            returnProcessParams(params){
                let processParam = {
                    "originalName":params.filename,
                    "businessType":"SysTest",
                    "businessId":"22222",
                    "tempId":"111111",
                    "businessProperty":"photo",
                    "basedictStorage":"localServer",
                    "file":params.file,
                    "totalChunks":params.totalChunks,
                    "totalSize":params.totalSize,
                    "chunkNumber":params.chunkNumber
                };
                return processParam;
            },
            //开始上传。
            uploadStart(arg){
                console.log('uploadStart', arguments)
            },
            //添加了一个文件，一般用作文件校验，如果给 file 增加 ignored 属性为 true 的话就会被过滤掉。
            fileAdded(file){
                console.log('fileAdded', file)
            },
            // 上传完成
            complete() {
                console.log('complete', arguments)
            },
            // 一个根文件（文件夹）成功上传完成。
            fileComplete() {
                console.log('file complete', arguments);
                /*const file = arguments[0].file;
                let param = {
                    name: file.name,
                    identifier: arguments[0].uniqueIdentifier,
                    totalSize: file.size,
                    type: file.type
                };
                mergeFile(param).then((res)=> {
                    console.log(res);
                }).catch(function (error) {
                    console.log(error);
                });*/
            },
            //移除一个文件（文件夹）。
            fileRemoved(file){
                console.log('fileRemoved', file)
            },
            //所选择的文件们添加到上传队列后触发。
            fileSubmitted(files, fileList){
                console.log('fileSubmitted', files);
                console.log('fileSubmitted', fileList);
            },
            onFileSuccess(rootFile, file, response, chunk) {
                let res = JSON.parse(response);
                console.log(res);
            },
            onFileProgress(rootFile, file, chunk) {
                ;
                console.log(`上传中 ${file.name}，chunk：${chunk.startByte / 1024 / 1024} ~ ${chunk.endByte / 1024 / 1024}`)
            },
            onFileError(file){
                console.log('onFileError', file);
            }
        },
        mounted() {
            this.$nextTick(() => {
                window.uploader = this.$refs.uploader.uploader
            })
        }
    }
</script>

<style>
    .uploader-example {
        width: 880px;
        padding: 15px;
        margin: 40px auto 0;
        font-size: 12px;
        box-shadow: 0 0 10px rgba(0, 0, 0, .4);
    }
    .uploader-example .uploader-btn {
        margin-right: 4px;
    }
    .uploader-example .uploader-list {
        max-height: 440px;
        overflow: auto;
        overflow-x: hidden;
        overflow-y: auto;
    }
</style>
